(function ($, document, window) {
    'use strict';

    $(document).ready(function () {
        /**
         * Dispatch a resize event after 1 second to fix an issue where the Google reviews widget
         * was not initialising with the correct number of slides, causing layout issues.
         */
        setTimeout(function () {
            window.dispatchEvent(new Event('resize'))
        }, 1000);
    });

})(jQuery, document, window);
